import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Skeleton,
  Button,
} from '@mui/material';
import React from 'react';
import {useGetShippingMethodsQuery} from 'api';
import AddIcon from '@mui/icons-material/Add';
import ShippingMethodDeleteIconButton from './ShippingMethodDeleteIconButton';
import CreateShippingMethodModal from './MethodCreateModal';
import ShippingMethodEditIconButton from './ShippingMethodEditIconButton';

const totalColumns = 3;

function ShippingMethodsTable() {
  const {data, isLoading, isError, isSuccess} = useGetShippingMethodsQuery();
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <>
      <CreateShippingMethodModal
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
      />
      <TableContainer component={Paper}>
        <Table sx={{minWidth: 650}} aria-label="ShippingMethod Table">
          <TableHead>
            <TableRow>
              <TableCell colSpan={totalColumns - 1}>Shipping Method</TableCell>
              <TableCell align="right">
                <Button
                  onClick={() => {
                    setIsOpen(true);
                  }}
                  disableElevation
                  variant="contained"
                  endIcon={<AddIcon />}
                >
                  Add
                </Button>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell align="center">Title</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isSuccess &&
              Boolean(data?.length) &&
              data.map(row => (
                <TableRow key={row._id} sx={{'&:last-child td, &:last-child th': {border: 0}}}>
                  <TableCell component="th" scope="row">
                    {row._id}
                  </TableCell>
                  <TableCell align="center">{row.title}</TableCell>
                  <TableCell align="center">
                    <ShippingMethodEditIconButton ShippingMethod={row} />
                    <ShippingMethodDeleteIconButton ShippingMethodId={row._id} />
                  </TableCell>
                </TableRow>
              ))}
            {Boolean(isSuccess && !data?.length) && (
              <TableRow>
                <TableCell colSpan={totalColumns}>No ShippingMethod found</TableCell>
              </TableRow>
            )}
            {isError && (
              <TableRow>
                <TableCell colSpan={totalColumns}>
                  <Typography color="error">Failed to fetch ShippingMethods.</Typography>
                </TableCell>
              </TableRow>
            )}
            {isLoading && (
              <TableRow>
                {Array.from(Array(totalColumns).keys()).map(key => (
                  <TableCell key={key}>
                    <Skeleton variant="text" />
                  </TableCell>
                ))}
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

export default ShippingMethodsTable;
